import React, { useState } from 'react';
import { Container, Card } from 'react-bootstrap';
import DateTimePicker from './DateTimePicker';

const TestDateTimePicker = () => {
  const [selectedDateTime, setSelectedDateTime] = useState(new Date());

  const handleDateTimeChange = (date, isASAP) => {
    setSelectedDateTime(date);
    console.log('Selected DateTime:', date, 'ASAP:', isASAP);
  };

  return (
    <Container className="py-4">
      <Card>
        <Card.Header>
          <h4>Test DateTimePicker</h4>
        </Card.Header>
        <Card.Body>
          <DateTimePicker
            value={selectedDateTime}
            onChange={handleDateTimeChange}
            label="Test Date & Time"
            className="mb-3"
            use24Hour={false}
            show24HourToggle={false}
          />
          
          <div className="mt-3">
            <h6>Selected DateTime:</h6>
            <p>{selectedDateTime.toLocaleString()}</p>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default TestDateTimePicker; 